<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title>Add a host to {{ hsct.huis_code }}</v-card-title>
            <v-divider></v-divider>
            <!-- <p class=".title ma-2">Add a host to {{hsct.huis_code }} </p> -->
            <v-form ref="addHsct" v-model="addHsctValid">
                <v-row no-gutters>
                    <v-col class="ma-2">
                        <v-text-field v-model="hsct.eign_code" :rules="eign_codeRules" label="Host ID"></v-text-field>
                    </v-col>
                </v-row>  
                <v-row no-gutters>
                    <v-col class="ma-2">
                        <v-select v-model="hsct.hsct_rol" :items="hsct_rolKeuzes" label="Role" :rules="hsct_rolRules"></v-select>
                    </v-col>
                </v-row>    
                <v-row no-gutters v-if="hsct.hsct_rol === 'Other'">
                    <v-col class="ma-2">
                        <v-textarea v-model="hsct.hsct_ctrl_detail" label="Role details" rows=3 :rules="hsct_detailRules"></v-textarea>
                    </v-col>
                </v-row>   
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addHsct" :disabled="!addHsctValid">Save</v-btn>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    // import {bus} from "../../../main";

    export default {
        data() { 
            return {
                dialog: false,
                addHsctValid: false,
                huis_encrid: null,
                eign_code: '',
                hsct_rolKeuzes: [],
                hsct: {},
                hsct_detailRules: [
                    v => (v && v.length >= 3) || "Details of role 'other' are required"
                ],
                 hsct_rolRules: [
                    v => (v && v.length >= 3) || "A Role is required"
                ],
                eign_codeRules: [
                    v => (v && v.length >= 3) || "A Host ID is required"
                ]
            }
        },
        methods: {
            open(huis_encrid) {
                var deze = this;
                this.$emit("showSnackbar");
                this.dialog = true;
                this.$axios.post("ares/json/ares/huis/hsct/getHuisToAddHsct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisToAddHsct"
                    },
                    getHuisToAddHsct: {
                        huis_encrid: huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hsct = res.data.getHuisToAddHsct;
                        res.data.getHuisToAddHsct.hsct_rolKeuzes.forEach(function(rol) {
                             deze.hsct_rolKeuzes.push(rol); 
                        });
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            addHsct() { 
                this.$axios.post("ares/json/ares/huis/hsct/addHsct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHsct"
                    },
                    addHsct: {
                        huis_encrid: this.hsct.huis_encrid,
                        hsct_rol: this.hsct.hsct_rol,
                        eign_code: this.hsct.eign_code,
                        hsct_ctrl_detail: this.hsct.hsct_ctrl_detail,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        if (res.data.addHsct.color == "success") { 
                            //setTimeout(() => { this.$router.reload('/huis/onHuis/' + res.data.addHsct.huis_encrid);  }, 2000);      
                            // bus.$emit("closeDialog", "reload");
                        }         
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHsct.text,
                            color: res.data.addHsct.color
                        }); 
                        this.$emit('updateData');
                        this.dialog = false;
                    }
                })
            },
        }
    }
</script>
